import { Button, ButtonProps, styled } from '@mui/material';
import { theme } from '~/shared/styles/theme';

interface PrimaryButtonProps extends Omit<ButtonProps, 'variant'> {
  variant?: 'green' | 'brown' | 'darkBrown';
}

export const PrimaryButton = ({
  variant = 'green',
  ...props
}: PrimaryButtonProps) => {
  if (variant === 'green') {
    return <GreenButton {...props} />;
  }

  if (variant === 'darkBrown') {
    return <DarkBrownButton {...props} />;
  }

  return <BrownButton {...props} />;
};

const BaseButton = styled(Button)({
  width: '100%',
  borderRadius: theme.tokens.borderRadius.full,
  fontSize: '16px',
  padding: theme.spacing(3),
  textTransform: 'none',
  transition: 'all 0.2s ease',
  '&:disabled': {
    opacity: 0.6,
  },
});

const GreenButton = styled(BaseButton)({
  backgroundColor: theme.palette.custom.green,
  color: theme.palette.common.white,
  '&:hover:not(:disabled)': {
    backgroundColor: '#3a7449',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  '&:active:not(:disabled)': {
    backgroundColor: '#2e5d3a',
  },
});

const BrownButton = styled(BaseButton)({
  backgroundColor: theme.palette.custom.textMain,
  color: theme.palette.common.white,
  '&:hover:not(:disabled)': {
    backgroundColor: '#6d4a34',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  '&:active:not(:disabled)': {
    backgroundColor: '#5a3a28',
  },
});

const DarkBrownButton = styled(BaseButton)({
  backgroundColor: theme.palette.custom.textTitle,
  color: theme.palette.common.white,
  '&:hover:not(:disabled)': {
    backgroundColor: '#3a2518',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  '&:active:not(:disabled)': {
    backgroundColor: '#2d1c12',
  },
  '&:disabled': {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.custom.textTitle,
  },
});
